<template>
  <div class="score-page">
    <login-after-head-center></login-after-head-center>
    <div id="member" class="container home-container flex">
      <side-nav></side-nav>
      <div id="order-us" class="award-page">
        <div class="home-allTitle award-title-cg score-title fc-bet">
          <span>积分明细</span>
          <score-return-link></score-return-link>
        </div>
        <div v-loading="summaryLoading" class="integral-summary">
          <div class="summary-item">
            <span>当前积分</span>
            <strong>{{ balance }}</strong>
          </div>
          <div class="summary-item">
            <span>品宣积分限制</span>
            <strong>{{ integralLimit }}<sup>*</sup></strong>
          </div>
          <div v-if="false" class="summary-item available">
            <span>普通商品可用</span>
            <strong>{{ availableIntegral }}</strong>
          </div>
        </div>
        <p class="integral-tip">当前积分（*仅限兑换品宣商品）</p>
        <div class="record-title">积分流水</div>
        <div v-loading="loading && records.length === 0" class="record-list" :aria-busy="loading">
          <div class="record-head">
            <span>事项</span>
            <span>时间</span>
            <span>变动积分</span>
          </div>
          <div v-if="!loading && !loadError && records.length === 0" class="empty-state">暂无积分明细</div>
          <div v-for="(record, index) in records" :key="index" class="record-row">
            <span>{{ record.title || '--' }}</span>
            <span>{{ record.createTime || '--' }}</span>
            <span :class="record.pm === 1 ? 'income' : 'expense'">
              {{ record.pm === 1 ? '+' : '-' }}{{ record.number || 0 }}
            </span>
          </div>
        </div>
        <infinite-list-footer
          :loading="loading"
          :error="loadError"
          :has-more="hasMore"
          :empty="records.length === 0"
          @load="loadMore"
        />
      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import { getIntegral, getIntegralLimit, getIntegralList } from '@/api/score'

export default {
  name: 'IntegralRecord',
  data () {
    return {
      balance: 0,
      integralLimit: 0,
      records: [],
      page: 1,
      limit: 20,
      hasMore: false,
      loading: false,
      loadError: false,
      summaryLoading: true
    }
  },
  computed: {
    availableIntegral () {
      return Math.max(Number(this.balance) - Number(this.integralLimit), 0)
    }
  },
  mounted () {
    Promise.all([this.loadSummary(), this.loadRecords()])
  },
  methods: {
    loadSummary () {
      return Promise.all([getIntegral(), getIntegralLimit()]).then(([balanceRes, limitRes]) => {
        this.balance = Number(balanceRes.data || 0)
        this.integralLimit = Number(limitRes.data || 0)
      }).catch(error => {
        this.$message.warning((error && error.msg) || '积分信息加载失败，请重试')
      }).finally(() => {
        this.summaryLoading = false
      })
    },
    loadRecords () {
      if (this.loading) return Promise.resolve()
      this.loading = true
      this.loadError = false
      const page = this.page
      return getIntegralList({ page, limit: this.limit }).then(res => {
        if (res.status !== 200 || !Array.isArray(res.data)) {
          throw new Error(res.msg || '积分明细加载失败，请重试')
        }
        const list = res.data
        this.records = this.records.concat(list)
        this.hasMore = list.length === this.limit
        this.page = page + 1
      }).catch(error => {
        this.loadError = true
        console.warn('积分明细加载失败', { page })
        this.$message.warning((error && (error.msg || error.message)) || '积分明细加载失败，请重试')
      }).finally(() => {
        this.loading = false
      })
    },
    loadMore () {
      if ((!this.hasMore && !this.loadError) || this.loading) return
      return this.loadRecords()
    }
  }
}
</script>

<style scoped lang="less">
.score-title {
  padding-right: 20px;
}
.integral-summary {
  display: flex;
  margin: 24px 0;
  border: 1px solid #e7eeee;
  background: #f7fbfa;
}
.summary-item {
  flex: 1;
  padding: 22px;
  border-right: 1px solid #e7eeee;
  text-align: center;
}
.summary-item:last-child {
  border-right: 0;
}
.summary-item span {
  display: block;
  color: #888;
}
.summary-item strong {
  display: block;
  margin-top: 12px;
  color: #333;
  font-size: 26px;
  font-weight: 500;
}
.summary-item:nth-child(-n+2) strong {
  color: #57aca7;
}
.summary-item strong sup {
  position: relative;
  top: -8px;
  margin-left: 2px;
  color: #e43d33;
  font-size: 14px;
}
.summary-item.available strong {
  color: #57aca7;
}
.integral-tip {
  margin: -14px 0 8px;
  color: #e43d33;
  font-size: 13px;
}
.record-title {
  padding: 15px 0;
  color: #333;
  font-size: 16px;
}
.record-list {
  min-height: 260px;
  border: 1px solid #eee;
}
.record-head,
.record-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) 140px;
  align-items: center;
  min-height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #f1f1f1;
}
.record-head {
  background: #f7f8f8;
  color: #666;
}
.record-row {
  color: #555;
}
.record-head span:nth-child(-n+2),
.record-row span:nth-child(-n+2) {
  text-align: center;
}
.record-row:last-child {
  border-bottom: 0;
}
.income {
  color: #333;
}
.expense {
  color: #57aca7;
}
.empty-state {
  padding: 100px 0;
  color: #999;
  text-align: center;
}
</style>
